import WarningIcon from '../ui/WarningIcon';

const CarouselLoanDisclaimer: React.FC = () => {
  return (
    <div className="grid grid-cols-[auto,1fr] items-start gap-4 p-[11px] mt-4 bg-white border rounded-lg">
      <div className="mt-5">
        <WarningIcon />
      </div>

      <div className="!text-xs text-gray-900">
        <p
          className="!text-xs 
         font-bold !leading-[14.4px] !tracking-[0]"
        >
          Att låna kostar pengar!
        </p>
        <p className="!text-xs !leading-[15px]">
          Om du inte kan betala tillbaka skulden i tid riskerar du en
          betalningsanmärkning. Det kan leda till svårigheter att få hyra
          bostad, teckna abonnemang och få nya lån. För stöd, vänd dig till
          budget- och skuldrådgivningen i din kommun. Kontaktuppgifter finns på{' '}
          <a
            href="https://www.konsumentverket.se"
            target="_blank"
            rel="noopener noreferrer"
            className="underline !text-xs"
          >
            konsumentverket.se
          </a>
        </p>
      </div>
    </div>
  );
};

export default CarouselLoanDisclaimer;
